import {
  AnalyticsField,
  FilterComparison,
  FilterLogic,
  PivotTableLayout,
  Widget,
} from '@types'

import { LINKED_TRANSACTION_FIELD } from '@/const'
import { DEFAULT_COLS } from '@/views/Dashboards/Dashboard/Widgets/LinkedTransactions/utils/const'
import { DEFAULT_CONFIG_NAME } from '@/components/DS/patterns/Pivot/utils/const'

import { generateRandomKey } from '@/helpers/common'

export const getDefaultLinkedTransactionsAttrs = (): Widget['attrs'] => ({
  count: 15,
  filter: {
    params: [
      {
        key: generateRandomKey(),
        params: [
          {
            key: generateRandomKey(),
            comparison: FilterComparison.NOTCONTAINS,
            field: LINKED_TRANSACTION_FIELD.TAGS,
            value: 'exclude',
          },
        ],
        logic: FilterLogic.AND,
      },
    ],
    logic: FilterLogic.AND,
  },
  cols: DEFAULT_COLS,
})

const getDefaultAmountPivotAttrs = (valueField: string): Widget['attrs'] => ({
  index: 0,
  configs: [
    {
      name: DEFAULT_CONFIG_NAME,
      open: true,
      layout: PivotTableLayout.MODERN,
      filter: {
        params: [
          {
            params: [
              {
                key: generateRandomKey(),
                comparison: FilterComparison.NOTEQ,
                field: valueField,
                value: '0',
              },
            ],
            logic: FilterLogic.AND,
            key: generateRandomKey(),
          },
        ],
        logic: FilterLogic.AND,
      },
      sortColumns: [],
      sortRows: [],
    },
  ],
})

export const getDefaultCashFlowProjectionsAttrs = (): Widget['attrs'] => ({
  columns: ['account_name', 'asset_name', 'value'],
  projectionBy: 'month',
})

export const getDefaultValuePivotAttrs = (): Widget['attrs'] => getDefaultAmountPivotAttrs(AnalyticsField.POSITION_CLOSE)

export const getDefaultTreePivotAttrs = (): Widget['attrs'] => getDefaultAmountPivotAttrs('value')
